import { render, staticRenderFns } from "./PendenciesExpired.vue?vue&type=template&id=4743ce4a&scoped=true"
import script from "./PendenciesExpired.vue?vue&type=script&lang=js"
export * from "./PendenciesExpired.vue?vue&type=script&lang=js"
import style0 from "./PendenciesExpired.vue?vue&type=style&index=0&id=4743ce4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4743ce4a",
  null
  
)

export default component.exports